const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the workshop assignment
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('workshopAssignWait', ['Application', 'Authorization', 'AdminUsers', 'UserWorkshops', '$translate', function(Application, Authorization, AdminUsers, UserWorkshops, $translate) {
  return {
    restrict: 'E',
    scope: {
      instance: '=',
      workshop: '=',
      showHide: '=',
      type: '=',
      updateLists: '&'
    },
    template: require('../../templates/directives/workshop-assign-wait.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.queryChanged = false;
      self.per_page = 20;
      self.endOfLine = true;
      self.selectionCount = 0;
      self.restrictions = {};
      self.selected_users = [];
      self.creating = false;
      var assignList = {
        in: {},
        nin: {},
        queries: []
      };
      var queryOptions = {
        linked_locations: 'array',
        linked_departments: 'array',
        linked_teams: 'array',
        linked_org_level: 'text',
        linked_grade: 'text',
        $or: 'textMatch',
        role: 'text',
        manager_email: 'text',
        hired: 'date',
        createdAt: 'date',
        last_login: 'date'
      };

      self.individuals = {};
      var getStandardQuery = function(){
        var q = {
          page: 1,
          per_page: self.per_page,
          fields: '_id,first_name,last_name,email,full_name,role,image,linked_departments,linked_locations,linked_org_level,linked_grade,linked_teams,job_title,last_login,createdAt,hired,manager_email',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name',
          'linked_teams-populate': 'name',
          'linked_org_level-populate': 'name',
          'linked_grade-populate': 'name',
        };
        if ($scope.manager && $scope.manager.email) {
          q.manager_email = $scope.manager.email;
        } else {
          q.prioritize_creator = true;
        }
        return q;
      };

      self.query = getStandardQuery();

      self.load = function () {
        self.disableScroll = true;
        var userPromise;

        if (assignList.queries.length || assignList.in.length || assignList.nin.length) {
          var items = {};
          items.queries = assignList.queries;
          items.assignee_in = Object.keys(assignList.in);
          items.assignee_nin = Object.keys(assignList.nin);
          userPromise = AdminUsers.findFromQueryAndCheck({}, {find_query: self.query, match_query: items}).$promise
        } else {
          userPromise = AdminUsers.findFromQuery({}, self.query).$promise;
        }

        userPromise.then(function (results) {
          if (results.users.length < self.per_page) {
            self.endOfLine = true;
          }
          if (self.query.page === 1 || !self.users) {
            self.users = results.users;
          } else {
            self.users = self.users.concat(results.users);
          }
          if (!self.endOfLine) {
            self.disableScroll = false;
          }
          if (!self.query.queries) {
            self.users = [];
          }
          self.selected_users = results.selected_users || [];
        }).catch(function (error) {
          console.log('Error getting users:', error);
        });
      };
      self.nextPage = function() {
        self.query.page++;
        self.load();
      };
      self.onQuery = function(opts) {
        self.endOfLine = false;
        self.allChecked = false;
        self.query = getStandardQuery();
        if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
          self.queryChanged = false;
          self.load();
          return;
        }
        self.queryChanged = true;
        self.query.page = 1;
        self.query.queries = [opts];

        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };

      self.preview = {
        page: 1,
        per_page: 20,
        nextAllowed: false,
        show: false,
        getUsers: function() {
          var items = {
            fields: '_id,first_name,last_name,email,full_name,image,job_title,linked_locations,linked_departments,role,hired,createdAt,last_login,linked_teams,linked_org_level,linked_grade',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name',
            page: self.preview.page,
            per_page: self.preview.per_page,
            queries: assignList.queries,
            assignee_in: Object.keys(assignList.in),
            assignee_nin: [].concat(Object.keys(assignList.nin), self.exclusions)
          };
          self.preview.show = true;

          AdminUsers.findFromQuery({}, items).$promise
          .then(function(results) {
            var users = results.users;
            self.preview.users = users;
            if (users.length < self.preview.per_page) {
              self.preview.nextAllowed = false;
              return;
            }
            self.preview.nextAllowed = true;
          });
        },
        nextPage: function() {
          self.preview.page++;
          self.preview.getUsers();
        },
        previousPage: function() {
          if (self.preview.page) {
            self.preview.page--;
            self.preview.getUsers();
          }
        }
      };

      // Functions for selecting and deselecting users to assign
      self.userClick = function(user) {
        if (self.isUserChecked(user)) {
          self.uncheckUser(user);
          return;
        }
        self.checkUser(user);
      };
      self.checkUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.nin[id]) {
          delete assignList.nin[id];
        }
        assignList.in[id] = true;
        getCount();
      };
      self.uncheckUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.in[id]) {
          delete assignList.in[id];
        }
        assignList.nin[id] = true;
        getCount();
      };
      self.selectAll = function() {

        if (self.allChecked) {
          assignList.queries.pop();
          self.allChecked = false;
          getCount();
          return;
        }
        self.allChecked = true;
        if (self.query._id) {
          self.checkUser(null, self.query._id);
          return;
        }
        if ($scope.manager) {
          self.query.manager_email = $scope.manager.email
        }

        var queryAddition = self.query && self.query.queries && self.query.queries[0];

        assignList.queries.push(queryAddition);
        getCount();
      };
      self.isUserChecked = function(user) {
        if (assignList.in[user._id]) {
          self.individuals[user._id] = true;
          return true;
        }
        if (assignList.nin[user._id]) {
          self.individuals[user._id] = false;
          return false;
        }
        if (self.allChecked) {
          self.individuals[user._id] = true;
          return true;
        }
        if (self.selected_users.indexOf(user._id) !== -1) {
          self.individuals[user._id] = true;
          return true;
        }
        return self.checkQueries(user);
      };

      //Will always return false now (deprecated)
      self.checkQueries = function(user) {
        if (!assignList.queries || !assignList.queries.length) {
          self.individuals[user._id] = false;
          return false;
        }
        for (var i = 0; i < assignList.queries.length; i++) {
          var current = assignList.queries[i];
          var currentFailed = false;
          for (var key in queryOptions) {
            if (current[key]) {
              var option = current[key]
              if (typeof option === 'string' && option.indexOf('$in') !== -1) {
                option = option.split(',');
                option.splice(0, 2);
              }
              if (!self.fieldCheck(user, key, option)) {
                currentFailed = true;
                break;
              }
            }
          }
        }
        self.individuals[user._id] = false;
        return false;
      };

      //Deprecated
      self.fieldCheck = function(user, field, option) {
        var text;
        if (!field || typeof field !== 'string') {
          return false;
        }

        switch (field) {
          case 'linked_locations':
            if (!user.linked_locations || !user.linked_locations[0] || !user.linked_locations[0]._id || option.indexOf(user.linked_locations[0]._id) === -1) {
              return false;
            }
            return true;
          case 'linked_departments':
            if (!user.linked_departments || !user.linked_departments[0] || !user.linked_departments[0]._id || option.indexOf(user.linked_departments[0]._id) === -1) {
              return false;
            }
            return true;
          case 'linked_teams':
            if (!user.linked_teams || !user.linked_teams[0]) {
              return false;
            }
            for (var i = 0; i < user.linked_teams.length; i++) {
              if (option.indexOf(user.linked_teams[i]) !== -1) {
                return true;
              }
            }
            return false;
          case 'linked_org_level':
            if (!user.linked_org_level) {
              return false;
            }
            if (option.indexOf(user.linked_org_level) !== -1) {
              return true;
            }
            return false;
          case 'linked_grade':
            if (!user.linked_grade) {
              return false;
            }
            if (option.indexOf(user.linked_grade) !== -1) {
              return true;
            }
            return false;
          case '$or':
            text = option.split(',')[4];
            if (user.full_name && user.full_name.indexOf(text) !== -1 || user.email && user.email.indexOf(text) !== -1 || user.job_title && user.job_title.indexOf(text) !== -1) {
              return true;
            }
            return false;
          case 'role':
            if (user.role && user.role === option) {
              return true;
            }
            return false;
          case 'hired':
            text = new Date(option.slice(10));
            if (user.hired && new Date(user.hired) > text) {
              return true;
            }
            return false;
          case 'createdAt':
            text = new Date(option.slice(10));
            if (user.createdAt && new Date(user.createdAt) > text) {
              return true;
            }
            return false;
          case 'last_login':
            text = new Date(option.slice(10));
            if (user.last_login && new Date(user.last_login) > text) {
              return true;
            }
            return false;
          default:
            return false;
        }
      };

      var getCount = function() {
        var items = {};
        items.queries = assignList.queries;
        items.assignee_in = Object.keys(assignList.in);
        items.assignee_nin = [].concat(Object.keys(assignList.nin), self.exclusions);
        items.count_only = true;
        self.overload = false;

        if (!items.queries.length && !items.assignee_in.length) {
          self.selectionCount = 0;
          return;
        }
        AdminUsers.findFromQuery({}, items).$promise
        .then(function(count) {
          self.selectionCount = count.count ? count.count : 0;
          var data = $scope.instance.data || {};

          // Add overload checks for workshops
          if ($scope.type === 'registered') {
            var existing = 0 + (data.absentees || 0) + (data.atendences || 0) + (data.registrations || 0);
            if ((self.selectionCount + existing) > $scope.instance.seats) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: self.translations['workshopAssignWait.seats_exceeded_warning']});
              self.overload = true;
            }
          }
          if ($scope.type === 'waitlist') {
            var existing = 0 + (data.waitlists || 0);
            if ((self.selectionCount + existing) > $scope.instance.waitlist_seats) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: self.translations['workshopAssignWait.waitlist_exceeded_warning']});
              self.overload = true;
            }
          }
        });
      };
      self.createAssignments = function() {
        self.creating = true;
        var user = Authorization.getAuthToken().user._id;
        if (!user) {
          return;
        }
        var body = {
          assignees: {},
          workshop_instance: $scope.instance._id,
          workshop: $scope.workshop._id
        };
        body.assignees.queries = assignList.queries;
        body.assignees.in = Object.keys(assignList.in);
        body.assignees.nin = Object.keys(assignList.nin);
        body.type = $scope.type === 'registered' ? 'register' : $scope.type === 'waitlist' ? 'waitlist' : null;

        UserWorkshops.queryJoinWait({}, body).$promise
        .then(function(results) {
          $scope.updateLists();
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['manage.assign.content_confirmMessage'] });
          self.preview.show = false;
          $scope.showHide = false;
          self.clearChoices();
          self.creating = false;
        }).catch(function(error) {
          self.creating = false;
          Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['workshopAssignWait.error_adding_users']});
        });
      };

      // End functions for selecting and deselecting users to assign
      self.clearChoices = function() {
        assignList = {
          in: {},
          nin: {},
          queries: []
        };
        self.individuals = {};
        self.selectionCount = 0;
        self.queryChanged = false;
        self.clearQuery = true;
        self.allChecked = false;
      };
      self.cancel = function() {
        $scope.showHide = false;
        self.clearChoices();
      };
      self.resizeWindow = function() {
        self.windowHeight = $window.innerHeight - (document.querySelector('#scroll-selection').clientHeight);
      };
      angular.element($window).bind('resize', function() {
        self.resizeWindow();
        $scope.$apply();
      });
      $scope.$on('$destroy', function () {
        angular.element($window).unbind('resize');
      });
      $scope.$watch('showHide', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          if (!$scope.type) {
            $scope.showHide = false;
            return;
          }

          delete self.restrictions.manager_email;
          if ($scope.manager && $scope.manager.email) {
            self.restrictions.manager_email = $scope.manager.email;
          }
          if ((!self.users || !self.users.length) && $scope.manager) {
            self.query = getStandardQuery();
            self.load();
          }
          setTimeout(function() {
            // settimeout is necessary to take affect after elements have been resized
            self.resizeWindow();
            $scope.$apply();
          }, 100);
        }
      });

      $translate([
        'manage.assign.content_confirmMessage',
        'manage.assign.content_placeholder_search',
        'workshopAssignWait.seats_exceeded_warning',
        'workshopAssignWait.waitlist_exceeded_warning',
        'workshopAssignWait.error_adding_users'
      ]).then(function(results){
        self.translations = results;
      });

    }],
    controllerAs: 'assignments'
  };
}]);
